import { Tooltip } from "@mui/material";
import Image from "next/image";
import React from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const CompareLeftColumn = ({
  items,
  dronersLength,
}: {
  items: any;
  dronersLength: number;
}) => {
  return (
    <div
      className="compare__leftColumn"
      style={{
        display: dronersLength < 5 ? "grid" : "none",
        height: items.length === 2 ? "min-content" : "",
      }}
    >
      {items.map((item: any, i: number) => (
        <div className="compare__leftColumn--item" key={i}>
          <Image
            src={`/assets/${item.image}.png`}
            alt=""
            width="24"
            height="24"
          />
          <h3 className="compare__primaryText">{item.text}</h3>
          {item.tooltip && (
            <Tooltip
              title={item.tooltip}
              sx={{ width: "12px", height: "12px", marginLeft: "-4px" }}
            >
              <InfoOutlinedIcon />
            </Tooltip>
          )}
        </div>
      ))}
    </div>
  );
};

export default CompareLeftColumn;
